import { render, staticRenderFns } from "./shipping_methods.vue?vue&type=template&id=3ec57c84&lang=pug"
import script from "./shipping_methods.vue?vue&type=script&lang=js"
export * from "./shipping_methods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports